import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   searchValue:""
}

const searchSlice = createSlice({
  name: "searchSlice",
  initialState,
  reducers: {
    saveSearchValue: (state, action) => {
      state.searchValue = action?.payload?.data || ""
    },
    clearSearchValue: (state) => {
      state.searchValue = ""
    },
  },
});

export const { saveSearchValue, clearSearchValue } = searchSlice.actions;
export default searchSlice.reducer;